"use client";

import { cn } from "utils";
import { EdgenModalCreateAble } from "@components/EdgenModal";
import { OnboardingPaywallFreeTrialContent } from "./OnboardingPaywallFreeTrialContent";
import type { OnboardingPaywallFreeTrialContentProps } from "./types";

export interface OnboardingPaywallModalCallableParams
  extends OnboardingPaywallFreeTrialContentProps {
  isPC?: boolean;
  zIndex?: number;
}

/**
 * Onboarding Free trial / Accounts reconnect paywall shell.
 * H5 全屏动效对齐 Figma Annotation（`101951:175236`）：底缘升起 350ms / 退出 300ms；无 scrim。
 */
export const OnboardingPaywallModalCallable = (
  params: OnboardingPaywallModalCallableParams,
) => {
  const {
    isPC = false,
    onClose,
    trackingModuleName,
    paywallCopyOverrides,
    analyticsSource,
    onWebCheckoutRedirect,
    paywallVariant,
    zIndex,
  } = params;
  let modalInstance: Promise<boolean>;
  const handleClose = () => {
    onClose?.();
    EdgenModalCreateAble.end(modalInstance, false);
  };

  modalInstance = EdgenModalCreateAble.call({
    children: (
      <OnboardingPaywallFreeTrialContent
        isPc={isPC}
        onClose={handleClose}
        trackingModuleName={trackingModuleName}
        paywallCopyOverrides={paywallCopyOverrides}
        analyticsSource={analyticsSource}
        onWebCheckoutRedirect={onWebCheckoutRedirect}
        paywallVariant={paywallVariant}
      />
    ),
    zIndex,
    /** Figma 全屏 ✕ 页标准动效 rootClassName（见 globals.css） */
    domClassName: isPC ? undefined : "fullscreen-paywall-drawer",
    maskClosable: false,
    containerClassName: cn(
      "bg-background_solid_neutral_secondary",
      isPC ? "h-[712px] w-[480px]" : "h-full w-full",
    ),
    contentStyle: {
      borderRadius: isPC ? 16 : 0,
      width: isPC ? 480 : "100%",
      height: isPC ? 712 : "100%",
      padding: 0,
      overflow: "hidden",
    },
    containerStyle: {
      maxHeight: "100%",
    },
    destroyOnClose: true,
    onCancel: handleClose,
    showClose: false,
  });

  return modalInstance;
};
